/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react'
import {KTIcon} from '../../../../_elfaiotbbx/helpers'
import { formatWeight } from '../../../../_elfaiotbbx/helpers/WeightHelpers'

type Props = {
  className: string
  color: string
  svgIcon: string
  iconColor: string
  titleColor?: string
  descriptionColor?: string
  showData : string
  explanation: string
  explanation1: string
}

const IndicatorWeightLabel: React.FC<Props> = ({
  className,
  color,
  svgIcon,
  iconColor,
  titleColor,
  descriptionColor,
  showData,
  explanation,
  explanation1
}) => {
  
  // `title` ve `description` prop'lari KALDIRILDI: Props icinde ZORUNLUYDU ve
  // dort cagrinin dordu de Metronic sablonundan kalan "Shopping Cart" /
  // "Lands, Houses, Ranchos, Farms" degerlerini geciyordu -- ama bilesen bu iki
  // prop'u hicbir yerde RENDER ETMIYORDU. Yani ekranda gorunmuyorlardi; her
  // cagiranı anlamsız bir degeri yazmaya zorlayan olu bir sozlesmeydiler.
  //
  // Bu bilesen yalnizca gosterim yapiyor: deger prop olarak geliyor.
  //
  // Burada olu bir getBlackboxNumber() fonksiyonu, kullanilmayan bir blackboxNumber
  // state'i, bir createHeader() ve her mount'ta calisan bir console.log("123") vardi.
  // useEffect icindeki cagri da yorum satiriydi, yani fonksiyon hic kosmuyordu.
  return (
    <a href='#' className={`card bg-${color} hoverable ${className}`}>
      <div className='card-body'>
        <KTIcon iconName={svgIcon} className={`text-${iconColor} fs-3x ms-n1`} />

        <div className={`text-${titleColor} fw-bold fs-2 mb-2 mt-5`}>{explanation} : 
        {/* Ham parseFloat(...).toFixed(2) yerine ortak bicim (formatWeight):
            bin kg'in uzerinde ton, binlik ayraci Turkce. Kumulatif toplamlar
            alti-yedi haneye cikiyor ve "261058.00" okunmuyordu. */}
        {formatWeight(showData) !== '-' ? formatWeight(showData) : "bilinmiyor"}</div>

        <div className={`fw-semibold text-${descriptionColor}`}>{explanation1}</div>
      </div>
    </a>
  )
}

export {IndicatorWeightLabel}
